// extracted by mini-css-extract-plugin
module.exports = {"content":"notfound_content___NHm6","notfound":"notfound_notfound__YWFlL","code":"notfound_code__cwPCw","text":"notfound_text__oVHn4","boto":"notfound_boto__yk3we"};